import React, { useCallback } from 'react';
import { Tappable } from '@vectord/components';
import { useDispatch, batch } from 'react-redux';

import {
  COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES,
  setCoursePauseRequestApproveModalStage,
  setSelectedRequest,
} from 'features/courseResume';

function CoursePauseRequestApproveButton({ coursePauseRequest }) {
  const dispatch = useDispatch();

  const handleApprove = useCallback(() => {
    batch(() => {
      dispatch(setSelectedRequest(coursePauseRequest));
      dispatch(
        setCoursePauseRequestApproveModalStage(
          COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES.confirm
        )
      );
    });
  }, [dispatch, coursePauseRequest]);

  return (
    <Tappable
      onClick={handleApprove}
      className="primary bold btn-small"
      noHighlight
    >
      Approve
    </Tappable>
  );
}

export default CoursePauseRequestApproveButton;
